<template>
  <div class="visitor py-5">
    <b-container fluid>
      <h1 class="h2 text-gray-800 mb-4">Visitor List</h1>
      <b-table
        striped
        hover
        responsive
        :items="formattedVisitors"
        :per-page="perPage"
        :current-page="currentPage"
        id="visitor-list"
      >
        <template v-slot:cell(travel_china)="data">{{ data.value == 0 ? "No" : "Yes" }}</template>

        <template v-slot:cell(symptoms)="data">
          <ul>
            <li v-for="(x, key) in data.value" :key="key">{{ x }}</li>
          </ul>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="visitor-list"
      ></b-pagination>
    </b-container>
  </div>
</template>
<script>
const fb = require("../firebase");
export default {
  data() {
    return {
      visitors: [],
      perPage: 15,
      currentPage: 1
    };
  },
  created() {
    fb.db
      .collection("visitors")
      .orderBy("date", "desc")
      .get()
      .then(querySnapshot => {
        const documents = querySnapshot.docs.map(doc => doc.data());
        this.visitors = documents;
      });
  },
  computed: {
    formattedVisitors() {
      return this.visitors.map(item => {
        return {
          name: item.name,
          temperature: item.temperature,
          contact_no: item.contact_no,
          isTravelChina: item.travel_china,
          stateProvice: item.province_china,
          symptoms: item.symptoms,
          date: item.date
        };
      });
    }
  }
};
</script>